// --- Make localized WordPress data globally available ---
window.aftermetooData = window.aftermetooData || window.app || {}; // fallback if WP outputs old var name
window.app = window.aftermetooData;

// Optional: expose convenience keys for backward compatibility
const {
	geolocation_environment,
	geolocation_tooltip_text,
	geolocation_tooltip_label,
	provinces,
} = window.app;

// If you need these across multiple modules:
export const AppGlobals = {
	geolocation_environment,
	geolocation_tooltip_text,
	geolocation_tooltip_label,
	provinces,
};

// --- End global setup ---

// The full webpack entry adds the carousel modules before this shared runtime.
// Validated relaunch homepages use this runtime alone; all other behavior is shared.
import drawer from './drawer';
import './tldr-cards';
import './nav';
import './modal';
import './lazy-form';
import './tooltip';
import './glossary';
import './glossary-highlight';
import './lib/autocomplete';
import './share-story';
import './mailchimp';
import './map';
import './helpful-form';
import './share';
import './home';
import './taxonomy';
import './category';
import './tag';
import './resource-block';
import './search';
import './geolocation';
import './animation';
import './eap-test-form';
import './eapnumbers';
import './chatbase-triggers';
import './recruitment-form';
